import { render, staticRenderFns } from "./GraficoPiramide.vue?vue&type=template&id=43fb3a60&scoped=true&"
import script from "./GraficoPiramide.vue?vue&type=script&lang=js&"
export * from "./GraficoPiramide.vue?vue&type=script&lang=js&"
import style0 from "./GraficoPiramide.vue?vue&type=style&index=0&id=43fb3a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fb3a60",
  null
  
)

export default component.exports